const UserDetails = ({ email, neighborhood, phoneNumber, bio }) => {
  return (
    <div className="profile-details">
      <div className="profile-row">
        <span className="profile-label">Email</span>
        <span className="profile-value">{email}</span>
      </div>
      {neighborhood && (
        <div className="profile-row">
          <span className="profile-label">Neighborhood</span>
          <span className="profile-value">{neighborhood}</span>
        </div>
      )}
      {phoneNumber && (
        <div className="profile-row">
          <span className="profile-label">Phone</span>
          <span className="profile-value">{phoneNumber}</span>
        </div>
      )}
      {bio && (
        <div className="profile-row">
          <span className="profile-label">Bio</span>
          <span className="profile-value">{bio}</span>
        </div>
      )}
    </div>
  );
};

export default UserDetails;
